import { z as zod } from 'zod';
import { DetailSchema, RelatedInfoSchema, ShowroomSchema } from "@/app/features/shared/types/schema";

export const SitePhotoArchiveSchema = zod.object({
    details: zod.array(DetailSchema),
    relatedInfos: zod.array(RelatedInfoSchema),
    showroom: ShowroomSchema.nullish(),
});
